__turbopack_context__.v({
  "body": "IconModal-module__4dFmpa__body",
  "button": "IconModal-module__4dFmpa__button",
  "description": "IconModal-module__4dFmpa__description",
  "icon": "IconModal-module__4dFmpa__icon",
  "root": "IconModal-module__4dFmpa__root",
  "title": "IconModal-module__4dFmpa__title",
});
